<template>
  <div>
    <b-row>
      <b-col>
        <b-card class="p-0">
          <div slot="header">
            <h4 id="consumptions" class="card-title m-0">Доступные поля</h4>                      
          </div>

          <div v-for="element in listIn" :key="element.id">
            <c-switch  class="mx-1" color="primary" variant="pill" v-model="element.default" @change="onFieldChange($event,element)"/>{{element.name}}
          </div>
        </b-card>
      </b-col>
      <b-col>
        <b-card class="p-0">
          <div slot="header">
            <div class="d-flex">
              <h4 id="consumptions" class="card-title m-0">Поля отчета</h4>
              <div class="d-flex ml-auto">
                <b-form-radio-group 
                  id="basicInlineRadios"
                  class="mt-1"
                  :plain="true"
                  :options="[
                    {text: 'XLS',value: 'xls'},
                    {text: 'CSV',value: 'csv'},
                  ]"
                  v-model="format">
                </b-form-radio-group>
              </div>
            </div>
          </div>
          <draggable
            class="dragArea list-group"
            :list="itemsOut"
            :group="{ name: 'drag', pull: true, put: true }"
            v-bind="dragOptions"
          >
            <transition-group type="transition" :name="!drag ? 'flip-list' : null">
              <div class="list-group-item mb-1" v-for="element in itemsOut" :key="element.id">
                {{ element.name }}
              </div>
            </transition-group>
          </draggable>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import { Switch as cSwitch } from '@coreui/vue'
import draggable from 'vuedraggable'

export default {
  name: 'field-selector',

  components: { cSwitch, draggable },

  data: function() {
    return {
      drag: false
    }
  },

  props: {
    itemsIn: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    listIn() {
      return this.itemsIn
    },

    itemsOut: {
      get() {
        return this.value.dataOut;
      },
      set(val) {
        this.value.dataOut = val
        this.$emit('input', this.value);
      }
    },

    format: {
      get() {
        return this.value.format;
      },
      set(val) {
        this.value.format = val
        this.$emit('input', this.value);
      }
    },

    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
  },
  
  methods: {    
    onFieldChange(state, item) {
      if (state) {
        this.itemsOut.push(item)
      }
      else {
        var ind = this.itemsOut.findIndex((el) => el == item)
        if (ind >= 0) {
          this.itemsOut.splice(ind, 1)
        }
      }
    }
  },

  created() {
    this.value.dataOut = []
  }
}

</script>

